import React from 'react'

export function AboutPage() {
    return (
        <div>AboutPage!</div>
    )
}